import React from 'react';
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from 'perfect-scrollbar';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Header, Footer, Sidebar } from '../components';
import routes from '../routes';
import Modals from '../components/Modals';
import AccessDenied from '../components/AccessDenied';
import { getRoutes } from '../utils';
import { PermissionContext } from '../contexts';

let ps;

class Main extends React.Component {
  static contextType = PermissionContext;

  mainPanelRef = React.createRef();

  componentWillUnmount() {
    if (navigator.platform.indexOf('Win') > -1) {
      ps.destroy();
      document.body.classList.toggle('perfect-scrollbar-on');
    }
  }

  componentDidUpdate(e) {
    if (navigator.platform.indexOf('Win') > -1) {
      ps = new PerfectScrollbar(this.mainPanelRef.current);
      document.body.classList.toggle('perfect-scrollbar-on');
    }
    if (e.history.action === 'PUSH') {
      this.mainPanelRef.current.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
    }
  }

  render() {
    const { hasPermission } = this.context;

    return (
      <div className="wrapper">
        <Modals />
        <Sidebar {...this.props} routes={getRoutes(routes)} />
        <div className="main-panel" ref={this.mainPanelRef}>
          <Header {...this.props} />
          <Switch>
            {routes.map((prop, key) => {
              if (prop.views) {
                prop.views.map((prop2, key2) => {
                  return (
                    <Route
                      path={prop2.path}
                      component={prop2.component}
                      key={key2}
                    />
                  );
                });
              }

              if (prop.redirect) {
                return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
              }

              const hasAccess = hasPermission(prop.resource, prop.action);

              if (!hasAccess) {
                // The nav already hides these, but a bookmark or stale link can
                // still land here. Dropping the Route left a blank page; say why
                // instead.
                return (
                  <Route path={prop.path} key={key}>
                    <div className="content">
                      <AccessDenied
                        title={`You do not have access to ${prop.name}`}
                      />
                    </div>
                  </Route>
                );
              }

              return (
                <Route path={prop.path} component={prop.component} key={key} />
              );
            })}
          </Switch>
          <Footer fluid />
        </div>
      </div>
    );
  }
}

export default Main;
